import { Income, IncomeFilters } from '../types/income'

const incomeDateKey = (income: Income): string =>
  String(income.incomeDate || '').slice(0, 10)

export const incomeMatchesFilters = (
  income: Income,
  filters: IncomeFilters,
): boolean => {
  const nameQuery = filters.name.trim().toLocaleLowerCase()
  if (nameQuery && !income.name.toLocaleLowerCase().includes(nameQuery)) {
    return false
  }

  const dateKey = incomeDateKey(income)
  if (filters.startDate && dateKey < filters.startDate) {
    return false
  }

  if (filters.endDate && dateKey > filters.endDate) {
    return false
  }

  return true
}
